import axios from 'axios';
import { CrawledPopupStoreSummary } from './crawls.type';

interface CrawledPopupStoreSummaries {
  popupStores?: CrawledPopupStoreSummary[];
}

export const CrawlPopgaScheduledPopupStores = async (): Promise<CrawledPopupStoreSummary[]> => {
  try {
    const { data } = await axios.get<CrawledPopupStoreSummaries>('https://crawl.prezemadmin.com/popga-places-to-open');

    return data.popupStores ?? [];
  } catch {
    return [];
  }
}
